import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getWorkspacePreferences,
  putWorkspacePreferences,
  type WorkspaceLayoutInput,
  type WorkspaceLayoutPreference,
} from '../services/api/workspace';

export const workspacePreferenceKeys = {
  layout: (userId: string, companyId: string) =>
    ['workspace', 'preferences', userId, companyId] as const,
};

export function useWorkspacePreferences(userId?: string, companyId?: string | null) {
  return useQuery({
    queryKey: workspacePreferenceKeys.layout(userId ?? '', companyId ?? ''),
    queryFn: getWorkspacePreferences,
    enabled: Boolean(userId && companyId),
    staleTime: 60_000,
  });
}

export function useSaveWorkspacePreferences(userId?: string, companyId?: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (layout: WorkspaceLayoutInput) => putWorkspacePreferences(layout),
    onSuccess: (layout: WorkspaceLayoutPreference) => {
      if (!userId || !companyId) return;
      queryClient.setQueryData(workspacePreferenceKeys.layout(userId, companyId), layout);
    },
  });
}
